<template>
	<div
			class="button-bar"
			:class="{'no-spacing-bottom': noSpacingBottom, 'no-spacing-top': noSpacingTop}"
	>
		<div class="start">
			<slot name="default"></slot>
		</div>

		<div class="end">
			<slot name="end"></slot>
		</div>
	</div>
</template>

<script setup>
	defineProps({
		noSpacingBottom: {
			type: Boolean,
			default: false
		},
		noSpacingTop: {
			type: Boolean,
			default: false
		}
	});

</script>

<style scoped>
	.button-bar {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		padding: 10px 0;
		margin-top: 10px;
	}

	.button-bar.no-spacing-top {
		margin-top: 0;
		padding-top: 0;
	}

	.button-bar.no-spacing-bottom {
		margin-bottom: 0;
		padding-bottom: 0;
	}

	.start,
	.end {
		display: flex;
		align-self: center;
		gap: 10px;
		flex-wrap: wrap;
		flex: 0 1 auto;
		max-width: 100%;
	}

	.start {
		justify-self: start;
		margin-right: auto;
	}

	.end {
		justify-self: end;
		margin-left: auto;
	}

	.end > *,
	.start > * {
		flex: 0 0 auto;
	}
</style>
